import {AppService} from "../app/app.service";
import {PageResponse} from "../util/page-response";
import {Wallet} from "./wallet";
import {ManualEntry} from "./manual-entry";

class WalletService {

    static API_URL = "/api/carteiras/v2";

    static findAll = (page?: number, size?: number, sort?: string, filter?: string): Promise<PageResponse<Wallet>> => {
        return AppService.getAuthorized(this.API_URL, {
            page: page,
            size: size,
            sort: sort,
            id: sort?.startsWith('id') ? filter : '',
            descricao: sort?.startsWith('descricao') ? filter : ''
        }).then((result) => {
            return result.data;
        }).catch(() => {
            return {
                content: [],
                totalElements: 0
            };
        })
    };

    static findOne(id: number) {
        return AppService.getAuthorized(this.API_URL + "/" + id).then((result) => {
            return result.data;
        }).catch(() => {
            return null;
        })
    }

    static save(item: Wallet) {
        if (item.id) {
            return AppService.postAuthorized(this.API_URL + "/" + item.id, item);
        } else {
            return AppService.postAuthorized(this.API_URL, item);
        }
    }

    static delete(id: number) {
        return AppService.deleteAuthorized(this.API_URL + "/" + id);
    }

    static createWallet() {
        const wallet: Wallet = {
            descricao: ''
        };
        return wallet;
    }

    static manualEntry(entry: ManualEntry) {
        return AppService.postAuthorized(this.API_URL + "/manual-entry", entry);
    }

    static movement(originWallet: number, destinyWallet: number, amount: number) {
        return AppService.getAuthorized(this.API_URL + "/movement", {
            origem: originWallet,
            destino: destinyWallet,
            valor: amount
        });
    }

    static async getCarteiraOverview(id: number, dataInicial: string, dataFinal: string) {
        return AppService.getAuthorized(this.API_URL + "/" + id + "/overview", {
            dataInicial: dataInicial,
            dataFinal: dataFinal
        });
    }

    static async getSaldoFinal(carteira: number, data: string) {
        return AppService.getAuthorized(this.API_URL + "/saldoFinal", {
            carteira: carteira,
            data: data
        }).then((result) => {
            return result.data;
        }).catch(() => {
            return null;
        })
    }
}

export {WalletService};